import { render, staticRenderFns } from "./OrderCalculationComponent.vue?vue&type=template&id=2b900ee4&scoped=true"
import script from "./OrderCalculationComponent.vue?vue&type=script&lang=ts"
export * from "./OrderCalculationComponent.vue?vue&type=script&lang=ts"
import style0 from "./OrderCalculationComponent.vue?vue&type=style&index=0&id=2b900ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b900ee4",
  null
  
)

export default component.exports